  <template>
    <div>
      <b-card no-body class="mb-0">
        <b-table-simple hover caption-top responsive class="rounded-bottom mb-0">
          <b-thead head-variant="light">
            <b-tr>
              <b-th>School Image</b-th>
              <b-th>School Name</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(school, index) in schools" :key="school._id">
              <b-td>
                <div v-if="school.schoolImg">
                  <template v-if="getFileExtensionFromUrl(school.schoolImg) === 'json'">
                    <LottieView :url="school.schoolImg" :forTopic="true" :key="keyForLottie" />
                  </template>
                  <template v-else-if="getFileExtensionFromUrl(school.schoolImg) === 'lottie'">
                    <DoLottieView :url="school.schoolImg" :forTopic="true" :id="`subjects_${index}`" :key="keyForLottie" />
                  </template>
                  <template v-else>
                    <img
                      :src="school.schoolImg || 'invalid_url.jpg'"
                      alt="School Image"
                      @error="imgError"
                      style="width: 100px; height: 100px"
                    />
                  </template>
                </div>
              </b-td>
              <b-td>{{ school.schoolName }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </div>
  </template>
  
  <script>
//   import axios from 'axios'
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    BFormCheckbox,
    BTab,
    BTabs,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import { BBreadcrumb } from "bootstrap-vue";
  import AddNewSchoolGrade from "@/views/app/list/users-list/AddNewSchoolGrade.vue";
  import AddEditSchoolGrade from "@/views/app/list/users-list/AddEditSchoolGrade.vue";
  import axios from "axios";
  import Ripple from "vue-ripple-directive";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
//   import LottieView from "./components/question/LottieView.vue";
  import DoLottieView from "@/views/components/question/DoLottieView.vue";
  import LottieView from "@/views/components/question/LottieView.vue";
//   import DoLottieView from "./components/question/DoLottieView.vue";
  import { v4 as uuidv4 } from 'uuid';
  export default {
    components: {
      BBreadcrumb,
      name: 'AssignGrade',
      AddNewSchoolGrade,
      AddEditSchoolGrade,
      BCard,
      BRow,
      ToastificationContent,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BTooltip,
      BTableSimple,
      BThead,
      BTr,
      BTh,
      BTd,
      BTbody,
      BTfoot,
      vSelect,
      BFormCheckbox,
      LottieView,
      DoLottieView,
      uuidv4,
      BTab,
      BTabs,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        schools: [], // use array for multiple schools
        keyForLottie: 0,
      }
    },
    mounted() {
      this.getTableData()
    },
    methods: {
      imgError(e) {
        e.target.src = 'https://via.placeholder.com/150'
      },
      getFileExtensionFromUrl(url) {
        return url?.split('.').pop()?.toLowerCase()
      },
      getTableData() {
        const schoolId = JSON.parse(localStorage.getItem("schoolid"))
        axios
          .get(process.env.VUE_APP_API_URL + `/school_info/get`, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
            params: { schoolId },
          })
          .then((res) => {
            this.schools = res.data.school || [] // now it's an array
            this.keyForLottie += 1
          })
          .catch((err) => {
            console.error("Failed to fetch school info:", err)
          })
      },
    },
  }
  </script>
  
  <style scoped>
  .stats-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    max-width: 400px;
    margin: 20px auto;
    overflow: hidden;
    text-align: center;
  }
  
  .card-image-top img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .card-content {
    padding: 15px;
  }
  
  .main-value {
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }
  </style>
  